<template>
  <div>
    <BlocoFiltroPesquisa
      :nome-do-form="nomeDoForm"
      @pesquisar="pesquisar"
      @novo="novo"
    >
      <template #form>
        <div class="row">
          <div class="form-group col-xs-12 col-sm-8 col-md-8 col-ld-8">
            <CampoGenerico
              id="enunciado"
              placeholder="Enunciado da questão"
              label="Enunciado"
              :valor="filtro.enunciado"
              @atualizar="filtro.enunciado = $event"
            />
          </div>
          <div class="form-group col-xs-6 col-sm-2 col-md-2 col-lg-2">
            <SelecionarDominio
              id="tipoResposta"
              dominio="TipoResposta"
              label="Tipo da resposta"
              :valor="filtro.typo"
              @atualizar="filtro.tipo = $event"
            />
          </div>
          <div class="form-group col-xs-6 col-sm-2 col-md-2 col-lg-2">
            <SelecionarSituacao
              id="ativo"
              :valor="filtro.ativo"
              @atualizar="filtro.ativo = $event"
            />
          </div>
        </div>
      </template>
    </BlocoFiltroPesquisa>
    <BlocoPaginadorPesquisa
      :total="total"
      :modo-resultado="modoResultado"
      @paginaAlterada="paginaAlterada"
      @modoAlterado="modoAlterado"
    />
    <BlocoResultadoPesquisa :total="total" :modo-resultado="modoResultado">
      <template #tabela><QuestaoTabela :questoes="questoes" /></template>
      <template #fichas>
        <div
          v-for="(q, index) in questoes"
          :id="'ficha' + index"
          :key="q._id"
          class="col-xs-12 col-sm-6 col-md-4 col-lg-3"
        >
          <QuestaoFicha :questao="q" />
        </div>
      </template>
    </BlocoResultadoPesquisa>
  </div>
</template>

<script>
import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import BlocoFiltroPesquisa from '@/componentes/formulario/BlocoFiltroPesquisa'
import BlocoPaginadorPesquisa from '@/componentes/formulario/BlocoPaginadorPesquisa'
import BlocoResultadoPesquisa from '@/componentes/formulario/BlocoResultadoPesquisa'
import CampoGenerico from '@/componentes/formulario/CampoGenerico'
import SelecionarDominio from '@/componentes/formulario/SelecionarDominio'
import SelecionarSituacao from '@/componentes/formulario/SelecionarSituacao'
import { useMenu } from '@/composables/useMenu'
import { usePesquisa } from '@/composables/usePesquisa'
import QuestaoServico from '@/servicos/QuestaoServico'

import QuestaoFicha from './QuestaoFicha'
import QuestaoTabela from './QuestaoTabela'

export default {
  components: {
    QuestaoFicha,
    QuestaoTabela,
    BlocoFiltroPesquisa,
    CampoGenerico,
    SelecionarDominio,
    SelecionarSituacao,
    BlocoResultadoPesquisa,
    BlocoPaginadorPesquisa,
  },
  setup() {
    const router = useRouter()
    const route = useRoute()
    const servico = new QuestaoServico()
    const nomeResultado = 'questoes'
    const nomeDoForm = 'QuestaoForm'
    const questoes = ref([])
    const filtro = ref({
      enunciado: '',
      tipo: '',
      ativo: '',
    })
    const pesquisa = usePesquisa({
      filtro,
      resultado: questoes,
      servico,
      nomeResultado,
      nomeDoForm,
      cacheFormularioAtivo: true,
      onNovo: () => router.replace({ path: route.path + '/cadastro' }),
    })
    useMenu(49)
    return { questoes, filtro, ...pesquisa }
  },
}
</script>
